import api from "./Api";

class EstoqueStService {
  GetEstoqueSt(payload) {
    return api.get("/v1/estoqueSt/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEstoqueSt(payload) {
    return api.post("/v1/estoqueSt/", payload).then((response) => {
      return response.data;
    });
  }

  PutEstoqueSt(payload) {
    return api.put("/v1/estoqueSt/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEstoqueSt(payload) {
    return api.delete("/v1/estoqueSt/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEstoqueStOData(payload) {
    return api.get("/OData/EstoqueSt" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new EstoqueStService();
